import { getDefaultClientOptions } from './utils/getDefaultClientOptions';
export function enforceDefaultClientOptions(AblyRealtime) {
  return class Realtime extends AblyRealtime {
    constructor(providedOptions) {
      const defaultClientOptions = getDefaultClientOptions();
      const clientOptions = Object.assign({}, defaultClientOptions, providedOptions);
      super(clientOptions);
    }
  };
}